import { render, staticRenderFns } from "./orderHeader.vue?vue&type=template&id=06563f1b&scoped=true&"
import script from "./orderHeader.vue?vue&type=script&lang=js&"
export * from "./orderHeader.vue?vue&type=script&lang=js&"
import style0 from "./orderHeader.vue?vue&type=style&index=0&id=06563f1b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06563f1b",
  null
  
)

export default component.exports